var map = {
	"./add.svg": 59357,
	"./add_active.svg": 33174,
	"./add_tabs.svg": 34964,
	"./ai.svg": 3438,
	"./ai_active.svg": 34243,
	"./alfred.svg": 79060,
	"./android.svg": 10977,
	"./android_active.svg": 17394,
	"./apple.svg": 36700,
	"./arrow.svg": 6831,
	"./arrow_alt.svg": 47135,
	"./article.svg": 94810,
	"./article_active.svg": 78103,
	"./audio.svg": 61034,
	"./back.svg": 909,
	"./blank.svg": 35246,
	"./book.svg": 98995,
	"./broken.svg": 9947,
	"./broken_active.svg": 17068,
	"./cache_failed.svg": 38938,
	"./cache_ready.svg": 54918,
	"./cache_retry.svg": 86009,
	"./calendar.svg": 56230,
	"./check.svg": 91196,
	"./check_active.svg": 81305,
	"./clear.svg": 24611,
	"./click.svg": 51852,
	"./close.svg": 49256,
	"./cloud.svg": 97079,
	"./cloud_active.svg": 95683,
	"./day.svg": 24426,
	"./default_collection.svg": 238,
	"./default_collection_active.svg": 72867,
	"./dev.svg": 68057,
	"./dev_active.svg": 59738,
	"./diamond.svg": 27392,
	"./diamond_active.svg": 53,
	"./document.svg": 72399,
	"./download.svg": 46460,
	"./dropbox.svg": 64330,
	"./dropbox_active.svg": 24423,
	"./duplicates.svg": 44846,
	"./duplicates_active.svg": 63907,
	"./edit.svg": 26928,
	"./edit_active.svg": 84517,
	"./exit.svg": 72612,
	"./export.svg": 43742,
	"./export_active.svg": 55187,
	"./extension.svg": 29971,
	"./extension_active.svg": 2324,
	"./facebook.svg": 9016,
	"./fonts.svg": 7794,
	"./fonts_active.svg": 75839,
	"./fullscreen.svg": 44855,
	"./fullscreen_active.svg": 912,
	"./gdrive.svg": 68601,
	"./gdrive_active.svg": 97370,
	"./github.svg": 31721,
	"./google.svg": 9777,
	"./help.svg": 9733,
	"./hide.svg": 55540,
	"./highlights.svg": 22663,
	"./history.svg": 63572,
	"./history_active.svg": 52865,
	"./hotkey.svg": 94354,
	"./ifttt.svg": 32335,
	"./image.svg": 56123,
	"./image_active.svg": 13100,
	"./import.svg": 66355,
	"./import_active.svg": 94164,
	"./inbox.svg": 65820,
	"./inbox_active.svg": 16665,
	"./info.svg": 49448,
	"./install.svg": 73949,
	"./install_active.svg": 33430,
	"./integrations.svg": 43149,
	"./integrations_active.svg": 37286,
	"./like.svg": 34085,
	"./like_active.svg": 65038,
	"./like_outline.svg": 41658,
	"./link.svg": 292,
	"./link_active.svg": 71025,
	"./lock.svg": 16793,
	"./markdown.svg": 16759,
	"./menu.svg": 49961,
	"./micro_add.svg": 29844,
	"./micro_ai.svg": 17389,
	"./micro_arrow.svg": 95970,
	"./micro_article.svg": 75795,
	"./micro_audio.svg": 15123,
	"./micro_book.svg": 91288,
	"./micro_broken.svg": 52000,
	"./micro_cache_failed.svg": 29085,
	"./micro_calendar.svg": 75437,
	"./micro_close.svg": 79841,
	"./micro_cloud.svg": 63674,
	"./micro_colapse.svg": 45380,
	"./micro_comment.svg": 12954,
	"./micro_document.svg": 30580,
	"./micro_download.svg": 78451,
	"./micro_duplicate.svg": 18546,
	"./micro_edit.svg": 47691,
	"./micro_expand.svg": 44155,
	"./micro_image.svg": 80726,
	"./micro_important.svg": 9247,
	"./micro_important_active.svg": 64744,
	"./micro_link.svg": 29763,
	"./micro_list.svg": 21083,
	"./micro_next.svg": 34587,
	"./micro_open.svg": 61859,
	"./micro_progress.svg": 36194,
	"./micro_public.svg": 96832,
	"./micro_reminder.svg": 73341,
	"./micro_screenshot.svg": 1611,
	"./micro_search.svg": 48899,
	"./micro_tag.svg": 15313,
	"./micro_tune.svg": 20849,
	"./micro_user.svg": 76462,
	"./micro_video.svg": 10476,
	"./more.svg": 51255,
	"./more_horizontal.svg": 17238,
	"./move_to.svg": 11469,
	"./move_to_active.svg": 38278,
	"./new_bookmark.svg": 59161,
	"./new_collection.svg": 21061,
	"./new_collection_active.svg": 61102,
	"./next.svg": 4455,
	"./night.svg": 694,
	"./note.svg": 72064,
	"./onedrive.svg": 93056,
	"./onedrive_active.svg": 97621,
	"./open.svg": 2836,
	"./public.svg": 32975,
	"./public_active.svg": 87704,
	"./raindrop_logo.svg": 92277,
	"./readwise.svg": 48728,
	"./refresh.svg": 2317,
	"./reminder.svg": 63278,
	"./reminder_active.svg": 79139,
	"./reminder_add.svg": 39134,
	"./rss.svg": 25440,
	"./search.svg": 37960,
	"./select_all.svg": 18800,
	"./select_none.svg": 12765,
	"./settings.svg": 37971,
	"./settings_active.svg": 36788,
	"./share.svg": 46461,
	"./sharing.svg": 88920,
	"./sharing_active.svg": 1437,
	"./show.svg": 49703,
	"./show_active.svg": 83776,
	"./sidebar.svg": 3616,
	"./sidebar_alt.svg": 2276,
	"./sidebar_alt_active.svg": 40593,
	"./slack.svg": 20036,
	"./sort_+lastUpdate.svg": 16589,
	"./sort_+lastUpdate_active.svg": 74790,
	"./sort_-created.svg": 23696,
	"./sort_-created_active.svg": 66757,
	"./sort_-domain.svg": 49244,
	"./sort_-domain_active.svg": 68569,
	"./sort_-lastUpdate.svg": 4411,
	"./sort_-lastUpdate_active.svg": 44204,
	"./sort_-title.svg": 18818,
	"./sort_-title_active.svg": 17999,
	"./sort_created.svg": 7809,
	"./sort_created_active.svg": 73298,
	"./sort_domain.svg": 40547,
	"./sort_domain_active.svg": 97988,
	"./sort_rating.svg": 33704,
	"./sort_rating_active.svg": 17837,
	"./sort_score.svg": 8519,
	"./sort_score_active.svg": 6752,
	"./sort_sort.svg": 69843,
	"./sort_sort_active.svg": 52916,
	"./sort_title.svg": 82219,
	"./sort_title_active.svg": 15836,
	"./tag.svg": 87836,
	"./tag_active.svg": 87961,
	"./trash.svg": 13322,
	"./trash_active.svg": 70631,
	"./twitter.svg": 55209,
	"./twitter_outline.svg": 53430,
	"./type.svg": 14876,
	"./upload.svg": 82799,
	"./upload_active.svg": 20760,
	"./user.svg": 36325,
	"./user_active.svg": 41070,
	"./video.svg": 56349,
	"./video_active.svg": 50102,
	"./view_grid.svg": 38602,
	"./view_grid_active.svg": 62023,
	"./view_list.svg": 25086,
	"./view_masonry.svg": 18027,
	"./view_simple.svg": 80364,
	"./vkontakte.svg": 9475,
	"./web.svg": 61662,
	"./web_active.svg": 54451,
	"./youtube.svg": 77631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35450;